__turbopack_context__.v({
  "ad": "NKv-rq_ad",
  "adSlots--1": "NKv-rq_adSlots--1",
  "adSlots--2": "NKv-rq_adSlots--2",
  "article": "NKv-rq_article",
  "container": "NKv-rq_container",
  "list": "NKv-rq_list",
});
